module.exports = __webpack_public_path__ + "img/ecommerce-gnome.d75c4746.png";